export enum DataAccessPermissionEnum{
  None = 0,

  Create = 1,

  Read = 2,

  Write = 4,

  Delete = 8
}

